import { atom } from "recoil";

export type TMatchVodViewer = {
  isOpen: boolean;
  matchId?: string;
  playerGameId?: string;
};

export const MatchVodViewerState = atom<TMatchVodViewer>({
  key: "MatchVodViewerState_v0.1",
  default: { isOpen: false },
});

export const MatchVodRequestedIds = atom<string[]>({
  key: "MatchVodRequestedIds_v0.1",
  default: [],
});
